module.exports = __webpack_public_path__ + "assets/img/team-guest-8b371a23.png";